export default __webpack_public_path__ + "static/media/1.fe85350f.jpg";